import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const isLoggedIn = localStorage.getItem("auth") === "true";

  // If user NOT logged in → go back to login page
  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  // If logged in → allow access
  return children;
}
